import { makeAutoObservable } from "mobx";
import DataLoading from 'react-sdk/DataLoading';
import Notifications from "react-sdk/Notifications/Notifications";
import Personnages from "react-sdk/Personnage/Personnages";
import PopupsManager from "react-sdk/PopupsManager";
import ScaleManager from "react-sdk/ScaleManager";
import Texts from "react-sdk/Texts";
import Analytics from "react-sdk/Vertx/Analytics";
import LP_api from "./LP_api";

function getUrlVar(name) {
  var url = new URL(window.location.href);
  return url.searchParams.get(name);
}


export const SCREENS = {
  LOADING: "LOADING",
  HOME: "HOME",
  LOGIN: "LOGIN",
  GAME: "GAME",
  END_GAME: "END_GAME"
}


export const POPUPS = {
  REGLES_TIRAGE: "REGLES_TIRAGE",
  MENTIONS_LEGALES: "MENTIONS_LEGALES",
  ORIENTATION: "ORIENTATION",
  TRAILER: "TRAILER",
  SETTINGS: "SETTINGS",
  VIDEO: "VIDEO"
}

class AppState {
  debugMode = false
  language = "fr"
  screen = SCREENS.LOADING

  lp_api = null
  saveExists = null

  dialogues = null
  vertxClient = null

  stickyHeader = false

  orientation = null

  constructor() {

    this.debugMode = getUrlVar("debug")
    ScaleManager.init(1920, 1080)


    this.lp_api = new LP_api()
    window.LP_API = this.lp_api

    window.addEventListener("beforeunload", function (e) {
      if (this.screen)
        Analytics.changeScreenEvents("screen." + this.screen, null)
    });

    DataLoading.getAllFiles(window.CONFIG.requiredFiles, window.CONFIG.root)
      .then(files => {
        this.haxeCanvas = document.createElement("canvas")
        Texts.init(files.texts, this.language)
        var json = []
        files.audios.map(audio => {
          json.push({
            id: audio.Id,
            type: audio.type,
            description: audio.description,
            path: audio.path,
            volume: audio.volume
          })
        })
        //SoundPlayer.init(json)
      })
      .then(() => {
        window.addEventListener('orientationchange', () => {
          // this.lp_api.updateForIOS();
          this.handleOrientationChange()
        });

        this.handleOrientationChange()
      })
      .then(() => Personnages.loadAll())
      // .then(() => this.vertxConnection())
      .then(() => {
        // Analytics.init(this.vertxClient);
        window.lime.embed(
          "main",
          this.haxeCanvas,
          1920,
          1080,
          //ScaleManager.w,
          //ScaleManager.h,
          {
            parameters: {},
          }
        )
      })
      .then(() => this.startGame())
      // .then(() => this.setScreen(SCREENS.HOME))

    makeAutoObservable(this, {
      vertxClient: false,
      haxeCanvas: false,
    })
  }

  handleOrientationChange() {

    console.log("orientation", window.screen.orientation.type)

    this.changeOrientation((window.screen.orientation.type === "portrait-primary" || screen.orientation.type === "portrait-secondary") ? "portrait" : "landscape")
  }

  changeOrientation(orientation) {
    this.orientation = orientation

    if (this.orientation === "portrait") {
      if (this.screen !== SCREENS.END_GAME) PopupsManager.open(POPUPS.ORIENTATION);
    }
    else if (PopupsManager.isOpened(POPUPS.ORIENTATION)) PopupsManager.close(POPUPS.ORIENTATION)

    ScaleManager.changeDimensions(this.orientation === "portrait" ? 1080 : 1920, this.orientation === "portrait" ? 1920 : 1080)
    console.log("orientation", this.orientation)

    if (this.lp_api.forceResizeRefresh)
      this.lp_api.forceResizeRefresh()

  }

  setScreen(id) {
    if (screen === SCREENS.GAME) this.changeOrientation("landscape")

    Analytics.changeScreenEvents("screen." + this.screen, "screen." + id)
    this.screen = id
  }

  handleGameReady() {
    this.gameReady = true

    if (this.lp_api.registeredFunctions.hasSave) {
      this.lp_api.registeredFunctions.hasSave(save_exists => {
        this.saveExists = save_exists
      })
    }
  }

  deleteSave() {
    this.lp_api.registeredFunctions.deleteSave()
    this.lp_api.registeredFunctions.hasSave(save_exists => {
      console.log("save_exists", save_exists)
      this.saveExists = save_exists
    })
  }

  startGame() {

    // this.lp_api.registeredFunctions.startGame(this.saveExists)
    this.setScreen(SCREENS.GAME)

    setTimeout(() => {
      this.lp_api.registeredFunctions.startGame(this.saveExists);
    }, 50); // délai en ms

   

  }
  setLanguage(l) {
    this.language = l
    Texts.setLanguage(l)
  }

  openLink(url) {
    window.open(url, "_blank");
  }

  vertxConnection() {
    const { universe, app, url, port } = window.CONFIG.vertx

    return new Promise((resolve, reject) => {
      this.vertxClient = window.gms.VertxClient.Create()
      this.vertxClient.SetUniverse(universe)
      this.vertxClient.SetApplication(app)
      this.vertxClient.SetAnonymousOnly(true)

      this.vertxClient.SetExternalLog(() => {})

      this.vertxClient.SIG_SocketConnection.Add((status, msg) => {
        console.log("SIG_SocketConnection", status, msg)
      })
      this.vertxClient.SIG_SessionStatus.Add((success, msg) => {
        console.log("SIG_SessionStatus", msg)
      })
      // localStorage.clear()
      this.vertxClient.OpenConnection(url, port, connected => {
        console.log("CONNECTED ? ", connected)

        if (connected) {
          
          resolve()
        } else {
          this.vertxClient.UserCreateAnonymousAndConnect(
            null,
            (success, msg, data) => {
              console.log("UserCreateAnonymousAndConnect", success, msg)
              if (success) {
                resolve()
              } else {
                Notifications.error("Impossible de se connecter")
                console.log("CONNECTION ERROR", msg)
              }
            }
          )
        }
      })
    })
  }

}


export default new AppState()
